import React, { FC } from 'react';
import Swiper from '@/components/Common/Swiper/Swiper';
import styles from './index.module.scss';
import clsx from 'clsx';

interface Props {
  images: {
    src: string;
    alt: string;
  }[];
}
const CardsSwiper: FC<Props> = ({ images }) => {
  return (
    <Swiper
      className={styles.swiperContainer}
      autoplay={{ delay: 1500, disableOnInteraction: false, waitForTransition: true }}
      slidesPerView={'auto'}
      centeredSlides={true}
      loop={true}
      speed={600}
    >
      {images.map(({ src, alt }, index) => (
        <div className={clsx([styles.card, 'swiper-slide', 'item'])} key={index}>
          <img src={src} alt={alt} />
        </div>
      ))}
    </Swiper>
  );
};

export default CardsSwiper;
